import styled from 'styled-components'

// ExtraBold renders text using 'Pangram Extra Bold'
// accepted props: size, color, alignment, margin
// defaults: h4 default, novo-green, center, h4 default margin
// pre-defined colors: novo-green, novo-dark-gray, novo-light-gray
export const ExtraBold = styled.h4`
  color: ${props =>
    props.color ? `var(--${props.color})` : 'var(--novo-green)'};
  font-family: 'Pangram Extra Bold';
  font-size: ${props => (props.size ? `${props.size}px` : null)};
  margin: ${props => (props.margin ? `${props.margin}` : null)};
  text-align: ${props => (props.alignment ? `${props.alignment}` : 'center')};
  width: 100%;
`
export const MediumWeightText = styled.p`
  color: ${props =>
    props.color ? `var(--${props.color})` : 'var(--novo-green)'};
  font-family: 'Pangram Medium';
  font-size: 16px;
  margin: ${props => (props.margin ? `${props.margin}` : null)};
`

export const BoldText = styled.p`
  color: ${props =>
    props.color ? `var(--${props.color})` : 'var(--novo-green)'};
  font-family: 'Pangram Bold';
  margin: ${props => (props.margin ? `${props.margin}` : null)};
`



// WEBPACK FOOTER //
// ./src/shared/textStyles.js